export default __webpack_public_path__ + "static/hackgen-3bf33e0fc079cb26652e5d10702a02b2.jpg";